<template>
  <div class="grid bg-white">
    <div class="grid-title">
      <h4 class="heading semi-bold">Emails</h4>
    </div>
    <div class="grid-body">
      <div class="row mb-2">
        <h3 class="text-bold col-md-10">
          {{ email.name }}
        </h3>
        <div class="col-md-2">
          <button
            class="btn shadow btn-primary create-new-button"
            @click="showAddNewRecipientModel()"
          >
            <i class="fa fa-plus-circle" aria-hidden="true"></i> Add New
            Recipient
          </button>
        </div>
      </div>

      <div class="grid bg-white">
        <div class="grid-body">
          <h4 class="text-bold">Recipients</h4>

          <vue-good-table
            styleClass="table table-bordered data-table"
            :rows="email.recipients"
            :columns="recipientColumns"
            :isLoading.sync="isLoading"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'recipient_name'">
                {{ props.row.recipient_name }}
              </span>
              <span v-else-if="props.column.field == 'recipient_email'">
                {{ props.row.recipient_email }}
              </span>
              <span v-else-if="props.column.field == 'action_id'">
                <button
                  class="btn btn-danger"
                  @click="deleteRecipient(props.row.id, props.row.email_id)"
                >
                  <i class="fa fa-trash-o" aria-hidden="true"></i>
                </button>
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>

      <div class="grid bg-white">
        <div class="grid-body">
          <h4 class="text-bold">Email logs</h4>

          <vue-good-table
            styleClass="table table-bordered data-table"
            :rows="email.statuses"
            :columns="statusColumns"
            :isLoading.sync="isLoading"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'date'">
                {{ ezy.date(props.row.updated_at) }}
              </span>
              <span v-else-if="props.column.field == 'status'">
                <span :class="'badge badge-' + getStatusColor(props.row.status)">
                  {{ props.row.status }}
                </span>
              </span>
              <span v-else-if="props.column.field == 'error_message'">
                {{ props.row.error_message ? props.row.error_message : "-" }}
              </span>
              <span v-else-if="props.column.field == 'action'">
                <button
                  class="btn btn-primary"
                  :disabled="props.row.status !== 'failed' || loading[props.row.id]"
                  @click="resendEmail(props.row.id)"
                >
                  Resend
                </button>
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
    <!-- Add new recipient Modal -->
    <div
      class="modal fade"
      id="add-recipients"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white text-bold">Add New Recipient</h5>
          </div>
          <div class="modal-body bg-white">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th width="50">
                    <button class="btn btn-primary" @click="addNewRecipient">
                      <i class="fa fa-plus-circle" aria-hidden="true"></i>
                    </button>
                  </th>
                  <th width="200">Recipient Name</th>
                  <th width="200">Recipient Email</th>
                  <th width="50"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(recipient, index) in newRecipients" :key="index">
                  <td>{{ index + 1 }}.</td>
                  <td>
                    <input
                      type="text"
                      placeholder="Name..."
                      class="form-control"
                      required
                      v-model="recipient.recipient_name"
                    />
                  </td>
                  <td>
                    <input
                      type="email"
                      placeholder="Email..."
                      class="form-control"
                      required
                      v-model="recipient.recipient_email"
                    />
                  </td>
                  <td class="text-right">
                    <button
                      class="btn btn-danger"
                      @click="newRecipients.splice(index, 1)"
                    >
                      <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="storeRecipients()"
            >
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";

export default {
  mounted() {
    this.emailId = this.$route.params.id;
    this.addNewRecipient();
    this.getEmail(this.emailId);
  },
  components: {
    VueGoodTable,
  },
  data() {
    return {
      isLoading: false,
      emailId: null,
      email: {},
      loading: {},
      newRecipients: [],
      recipientColumns: [
        {
          label: "Name",
          field: "recipient_name",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Email",
          field: "recipient_email",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Action",
          field: "action_id",
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center",
          width: "15%",
        },
      ],
      statusColumns: [
        {
          label: "Date",
          field: "date",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Status",
          field: "status",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Error message",
          field: "error_message",
          sortable: false,
          tdClass: "text-left",
          thClass: "text-left",
          width: "35%",
        },
        {
          label: "Action",
          field: "action",
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center",
          width: "15%",
        },
      ],
    };
  },
  watch: {
    $route: function () {
      this.emailId = this.$route.params.id;
    },
  },
  methods: {
    showAddNewRecipientModel(activeEmailModelId) {
      show_modal("#add-recipients");
      this.newRecipients = []; // Reset newRecipients when opening the modal
      this.addNewRecipient();
    },
    addNewRecipient() {
      this.newRecipients.push({
        email_id: this.emailId,
        recipient_name: "",
        recipient_email: "",
      });
    },
    getStatusColor(status) {
      switch (status) {
        case "delivered":
          return "primary";
        case "failed":
          return "danger";
      }
    },
    async getEmail(emailId) {
      this.isLoading = true;
      try {
        let res = await axios.get("/emails/" + emailId);
        this.email = res.data.email;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the developers"
          );
        }
      }
    },
    async deleteRecipient(recipientId, emailId) {
      if (await ezy.confirm("Are You Sure?")) {
        try {
          let res = await axios.delete("/emails_recipients/" + recipientId);
          if (res.data.status === "OK") {
            toastr.success("Recipient deleted successfully.");
            await this.getEmail(this.emailId);
          }
        } catch (error) {
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "There was some errors, please correct and try again, or contact the developers"
            );
          }
        }
      }
    },
    async storeRecipients() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      let temp = this.newRecipients.filter((recipient) => {
        return (
          !recipient.recipient_name ||
          !recipient.recipient_email ||
          !emailRegex.test(recipient.recipient_email)
        );
      });

      if (temp.length > 0) {
        Swal.fire(
          "ERROR",
          "Each recipient must have a name and a valid email",
          "error"
        );
        return false;
      }
      try {
        let res = await axios.post("/emails_recipients/", {
          recipients: this.newRecipients,
        });
        if (res.data.status === "OK") {
          toastr.success("Recipients added successfully.");
          await this.getEmail(this.emailId);
          hide_modal("#add-recipients");
        }
      } catch (error) {
        hide_modal("#add-recipients");
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else if (error.response.status === 422) {
          toastr.error(
            "An email recipient already exists for the specified email."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the developers"
          );
        }
      }
    },
    async resendEmail(emailStatusId) {
      if (await ezy.confirm("Are You Sure?")) {
        toastr.success("Resending email. This may take a moment...");
        this.$set(this.loading, emailStatusId, true);

        try {
          let res = await axios.post("/resend_email/" + emailStatusId);
          if (res.data.status === "OK") {
            toastr.success("Email is sent successfully.");
            await this.getEmail(this.emailId);
          }
          this.$set(this.loading, emailStatusId, false);
        } catch (error) {
          this.$set(this.loading, emailStatusId, false);
          await this.getEmail(this.emailId);
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            toastr.error(
              "Cannot send, please check the error message in the email logs table."
            );
          }
        }
      }
    },
  },
};
</script>


